import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KeywordsService {
  keywords: any;
  regex: RegExp;

  constructor() { }

  tokenize(searchString:string) {
    //   keywords = keywords.replace(new RegExp(',$', 'g'), '').split(',');
    let keywords = searchString.replace(new RegExp(' $', 'g'), ' ').split(' ');
    var i;
    var l = keywords.length;
    for (i = 0; i < l; i++) {
      keywords[i] = keywords[i].replace(new RegExp('^ | $', 'g'), ''); // + '\\b';'\\b' +
    }
    return keywords;
  }

  replacer(match, item) {
    //return '<span class="' + attrs.highlightClass + '">' + match + '</span>';
    //return '<span style="background-color:yellow">' + match + '</span>';
    return '<span style="background-color:var(--search-highlight-background); color:var(--search-highlight-text)">' + match + '</span>';


  }


  setKeywords(keywords) {
    if (!keywords || keywords.length == 0) return "";

    this.keywords = keywords;

    var tokenized = this.tokenize(keywords);
    this.regex = new RegExp(tokenized.join('|'), 'gmi');
  }

  clearKeywords() {
    this.keywords = null;
  }
  
}


/*
    var tokenize = function(keywords) {

      //   keywords = keywords.replace(new RegExp(',$', 'g'), '').split(',');
      keywords = keywords.replace(new RegExp(' $', 'g'), ' ').split(' ');
      var i;
      var l = keywords.length;
      for (i = 0; i < l; i++) {
        keywords[i] =  keywords[i].replace(new RegExp('^ | $', 'g'), ''); // + '\\b';'\\b' +
      }
      return keywords;
    };

    this.replacer = function(match, item) {
      //return '<span class="' + attrs.highlightClass + '">' + match + '</span>';
      return '<span style="background-color:yellow">' + match + '</span>';
    };


    this.setKeywords = function(keywords){
      if (!keywords || keywords.length==0) return "";

      this.keywords = keywords;

      var tokenized = tokenize(keywords);
      this.regex = new RegExp(tokenized.join('|'), 'gmi');
    }

    this.clearKeywords = function(){
     this.keywords = null;
    }
  }

*/